 
    $('.qtyplus').click(function(e){
      e.preventDefault();
      var currentVal = parseInt($('input[name="quantity"]').val());
      if (!isNaN(currentVal)) {
        $('input[name="quantity"]').val(currentVal + 1);
      } else {
        $('input[name="quantity"]').val(1);
      }

    });

    $(".qtyminus").click(function(e) {

      e.preventDefault();
      var currentVal = parseInt($('input[name="quantity"]').val());
      if (!isNaN(currentVal) && currentVal > 0) {
        $('input[name="quantity"]').val(currentVal - 1);
      } else {
        $('input[name="quantity"]').val(1);
      }

    });
  

      


    

  
$(function() {
    var style = document.createElement("link");
    style.href = "//kamakurayama-rusk.jp/cdn/shop/t/11/assets/anime.css?v=35156061190084669181709693682";
    style.rel = "stylesheet";
    style.type = "text/css";
    style.media = "all";
    document.head.appendChild(style);
});



document.addEventListener('DOMContentLoaded', function() {
    console.log('[search script] DOMContentLoaded');

    var searchWrap = document.getElementById('search-wrap');

    console.log('[search script] searchWrap = ', searchWrap);

    if (!searchWrap) {
        console.log('[search script] #search-wrap が見つかりません');
        return;
    }

    // 元の親要素と位置を覚えておく（必要なら戻せるように）
    var originalParent = searchWrap.parentNode;
    var originalNextSibling = searchWrap.nextElementSibling;

    // フルスクリーン用オーバーレイを作成
    var fullscreenOverlay = document.createElement('div');
    fullscreenOverlay.className = 'fullscreen-overlay';
    document.body.appendChild(fullscreenOverlay);

    console.log('[search script] fullscreenOverlay を追加しました');

    // 🔹 イベントデリゲーション：あとから出てくる .open-btn1 も拾う
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.open-btn1');
        if (!btn) return; // .open-btn1 をクリックしてないなら何もしない

        console.log('[search script] .open-btn1 がクリックされました');

        // オーバーレイを表示
        fullscreenOverlay.style.display = 'flex';

        // search-wrap をオーバーレイ内に移動
        fullscreenOverlay.appendChild(searchWrap);

        // フルスクリーン用のクラスを付与
        searchWrap.classList.add('fullscreen-content');

        // 元の position / z-index を一時的に上書きして前面に出す
        searchWrap.style.position = 'relative';
        searchWrap.style.top = '0';
        searchWrap.style.right = '0';
        searchWrap.style.zIndex = '1';
    });

    // 背景クリックで閉じる
    fullscreenOverlay.addEventListener('click', function(e) {
        if (e.target !== fullscreenOverlay) return;

        console.log('[search script] オーバーレイを閉じます');

        fullscreenOverlay.style.display = 'none';

        // search-wrap を元の位置に戻す
        if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
            originalParent.insertBefore(searchWrap, originalNextSibling);
        } else {
            originalParent.appendChild(searchWrap);
        }

        // フルスクリーン用クラス / スタイルを解除
        searchWrap.classList.remove('fullscreen-content');
        searchWrap.style.position = '';
        searchWrap.style.top = '';
        searchWrap.style.right = '';
        searchWrap.style.zIndex = ''; // CSS の z-index: -1; が効く状態に戻る
    });
});


  (function($) {
    // ドキュメントに対してデリゲート：動的に生成された .quick-view にも効く
    $(document)
      .off('click.quickview-force-close')
      .on('click.quickview-force-close', '.quick-view .overlay, .close-window', function(e) {
        e.preventDefault();

        // デバッグ用ログ（動いているか確認したら消してOK）
        console.log('QuickView close clicked');

        // モーダル本体を非表示
        $('.quick-view')
          .fadeOut(200, function() {
            $(this).removeClass('open-in option-loader');
          });

        // 念のため body/html のクラスも掃除（テーマによっては付いている）
        $('html, body').removeClass('quickview-open quick-view-open');

        return false;
      });
  })(jQuery);


// ローディングアニメーション

const targetElement = document.querySelector('.w_mill');
targetElement.style.animationName = "w_mill";